import { useState, useEffect } from "react"

function HandleToggle({name})
{
    const [toggled, setToggled] = useState(false)

    useEffect(() => {
        document.getElementById("Handle-Input-"+name).addEventListener('click', e => {
            e.stopImmediatePropagation()
        })
    }, [name])

    return <div className="handle-toggle" data-active={toggled} onClick={() => {
        setToggled(!toggled)
    }}>
        <div className="handle-top">
            <div className="handle-text">{name}</div>
            <div className="handle-check"></div>
        </div>
        <input type="link" className="handle-link" id={"Handle-Input-"+name} placeholder="Click to input link"></input>
    </div>
}

export default HandleToggle